import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useTranslation, useScrollAnimation, useStaggerAnimation } from '../hooks';

const FAQ = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  // Animation pour le titre
  const { ref: titleRef, isVisible: isTitleVisible } = useScrollAnimation({
    threshold: 0.2,
    rootMargin: '0px 0px -100px 0px'
  });

  // Animation stagger pour les questions
  const { containerRef, getItemStyle } = useStaggerAnimation(t.faq.items.length, {
    staggerDelay: 100,
    threshold: 0.1
  });

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Titre avec animation */}
        <div
          ref={titleRef}
          className="text-center mb-16"
          style={{
            opacity: isTitleVisible ? 1 : 0,
            transform: isTitleVisible ? 'translateY(0)' : 'translateY(40px)',
            transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
          }}
        >
          <h2 className="text-4xl lg:text-5xl font-light mb-6 tracking-wide">
            {t.faq.title}
          </h2>
          <p
            className="text-xl text-gray-600 leading-relaxed"
            style={{
              opacity: isTitleVisible ? 1 : 0,
              transform: isTitleVisible ? 'translateY(0)' : 'translateY(20px)',
              transition: 'opacity 0.8s ease-out 0.2s, transform 0.8s ease-out 0.2s'
            }}
          >
            {t.faq.subtitle}
          </p>
        </div>

        {/* Liste des questions avec accordéon */}
        <div ref={containerRef} className="space-y-4">
          {t.faq.items.map((item, index) => (
            <div
              key={index}
              style={getItemStyle(index)}
              className="border border-gray-200 rounded-lg overflow-hidden"
            >
              {/* Question (header cliquable) */}
              <button
                onClick={() => toggleQuestion(index)}
                className="w-full px-6 py-5 flex items-center justify-between bg-gray-50 hover:bg-gray-100 transition-colors duration-200 text-left"
                aria-expanded={openIndex === index}
              >
                <span className="text-lg font-medium text-gray-900 pr-4">
                  {item.question}
                </span>
                <ChevronDown
                  size={24}
                  className={`text-gray-500 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>

              {/* Réponse (contenu accordéon) */}
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 py-5 bg-white border-t border-gray-100">
                  <p className="text-gray-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
